import { render, staticRenderFns } from "./solicitudesSection.vue?vue&type=template&id=1aa9e213"
import script from "./solicitudesSection.vue?vue&type=script&lang=js"
export * from "./solicitudesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports